export default __webpack_public_path__ + "static/media/background-topic.a956200e.jpg";